import { render, staticRenderFns } from "./OfferCalcDetail.vue?vue&type=template&id=15a1dede&scoped=true&"
import script from "./OfferCalcDetail.vue?vue&type=script&lang=js&"
export * from "./OfferCalcDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfferCalcDetail.vue?vue&type=style&index=0&id=15a1dede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1dede",
  null
  
)

export default component.exports